import {NewsSource} from "../../../types/NewsVendors";
import {ObjectUtil} from "../../../../js/util/ObjectUtil";

export type SelectedNewsSources = {
    [key in NewsSource]?: boolean;
};

export type SelectionEntries = ReadonlyArray<SelectionEntry>;

export interface SelectionEntry {
    readonly source: NewsSource;
    readonly selected: boolean;
}

export function selectionEntries(selected: SelectedNewsSources): SelectionEntries {
    return ObjectUtil.keys(NewsSource)
                     .map((key) => NewsSource[key])
                     .sort()
                     .map((source) => ({source, selected: !!selected[source]}));
}

export function defaultSelection(): SelectedNewsSources {
    return allSelected();
}

export function allSelected(): SelectedNewsSources {
    return ObjectUtil.keys(NewsSource)
                     .map((key) => NewsSource[key])
                     .sort()
                     .map((source) => ({source, selected: true}))
                     .reduce((acc, next) => ({...acc, [next.source]: next.selected}), {});
}

export function allUnSelected(): SelectedNewsSources {
    return ObjectUtil.keys(NewsSource)
                     .map((key) => NewsSource[key])
                     .sort()
                     .map((source) => ({source, selected: false}))
                     .reduce((acc, next) => ({...acc, [next.source]: next.selected}), {});
}
